import { requiredLumpsumForTarget } from "../../engine/calculations";
import { currencyAxis, yearsAxis } from "./reckonerAxes";

const config = {
  key: "rr-lumpsum-need",
  title: "Lumpsum Need-Based Ready Reckoner",
  category: "Ready Reckoners",
  description: "See the one-time investment required today to reach a range of goal amounts over a range of durations.",
  reckoner: true,
  rowAxis: currencyAxis("Goal Amount", [10_00_000, 25_00_000, 50_00_000, 1_00_00_000, 2_00_00_000]),
  colAxis: yearsAxis("Years", [5, 10, 15, 20, 25, 30]),
  extraFields: [
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
  ],
  computeCell(goal, years, extra) {
    const annualRate = (Number(extra.returnRate) || 0) / 100;
    return requiredLumpsumForTarget(goal, annualRate, years);
  },
};

export default config;
